import {UPDATE_START} from '../actions/action-types';

export const initialState = {
  settings: {},
  translations: {},
  siteDataV2: {},
};

const startReducer = (state = initialState, action) => {
  if (action.type === UPDATE_START) {
    return {...state, ...action.values};
  }
  return state;
};

export default startReducer;
